import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import { useKeycloak } from "@react-keycloak/web";



export function Logout() {
  /*
   const keycloak = new Keycloak({
     //url: "http://keycloak-dotstow-dev-alb-1135353619.us-east-2.elb.amazonaws.com/auth",
     url:process.env.React_App_KEYCLOAK_URL,
     realm: "SNV3",
     clientId: "snv3_ui"
   });
   */
   //alert(keycloak.authenticated);
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch()
  useEffect(() => { 
    //alert(keycloak.authenticated);
    
    //keycloak.logout();
   // keycloak.logout({"redirect_uri":"/dashboard"});
   keycloak.logout({ redirectUri: window.location.origin })
    keycloak.authenticated = false;
   // window.location.href="/";
   /* 
   setTimeout(() => {
      //alert("25");
      //window.location.replace("/");
      //keycloak.login();   
      //window.location.href="/dashboard";
    }, "2000")
    */
    
    /*
    //alert(keycloak.authenticated);
    if(keycloak.authenticated)
    {
      alert("test");
      sessionStorage.clear();   
      keycloak.logout();  
      
      keycloak.logout();
      keycloak.authenticated = false;
      setTimeout(() => {
        //alert("25");
        //window.location.replace("/");
        //keycloak.login();   
        window.location.href="/dashboard";
      }, "2000")
    }else{
      window.location.href="/companydirectory";
    }
    */







   // keycloak.logout({ redirectUri: "/dashboard",id_token_hint:"12345" });
    /*
    setTimeout(() => {
      //alert("25");
      //window.location.replace("/");
      keycloak.login();   
      //window.location.href="/companydirectory";
    }, "1000")
    */

    //this.handleLogoutMain();
   // dispatch(auth.actions.logout())
   // document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      {/* <Redirect to='/auth/login' /> */}
    </Switch>
  )
}
